webpackJsonp([23,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	/**
	 * Created by jv on 24/04/2018.
	 */
	var Shared = __webpack_require__(10);
	var LanguageManager = __webpack_require__(6);
	var utils = __webpack_require__(3);
	
	// Styles
	__webpack_require__(770);
	
	$(function () {
	  Shared.shouldSetUpCreditsDialog = false;
	  Shared.init();
	
	  FaqPage.init();
	});
	
	var FaqPage = {};
	
	(function (FaqPage) {
	  FaqPage.init = function () {
	    setUpFaqCollapse();
	  };
	
	  function setUpFaqCollapse() {
	    var $faqTriggers = $(".section-faq .faq-trigger");
	    var $faqCollapseContent = $(".section-faq .faq-item .collapse");
	
	    $faqTriggers.off("click").on("click", function (e) {
	      $(e.currentTarget).parent().next().collapse("toggle");
	    });
	
	    $faqCollapseContent.off("show.bs.collapse").on("show.bs.collapse", function (e) {
	      $(e.currentTarget).parent().addClass("faq-collapse__show");
	    });
	
	    $faqCollapseContent.off("hide.bs.collapse").on("hide.bs.collapse", function (e) {
	      $(e.currentTarget).parent().removeClass("faq-collapse__show");
	    });
	  }
	})(FaqPage);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./nl-BE.json": 12
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 11;


/***/ }),

/***/ 770:
47

});


// WEBPACK FOOTER //
// js/marketing/faq.0d60fdce2669b8c7bf9c.js